import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

export type CompanyEventMenuResponse = {
  title: string;
  link: string;
}[];

export const eventMenuApiClient = {
  index: async (): Promise<ApiResult<CompanyEventMenuResponse>> => {
    return await axiosClient.get('/company/event-menus');
  },
};
